export default __webpack_public_path__ + "static/media/sketch-youth-tn.a16ff370.png";